<template>

    <section>

        <!-- トリガーになるボタンに data-modal="MySelectRoomCheckList" を追加 -->
        <button type="button" data-modal="MySelectRoomCheckList" v-on:click="modalShowClick">
            <span>My Select Room に追加する</span>
        </button>

        <!-- モーダル要素 ここから -->

        <!--:::::::::::::::::::::::::::::::::::::::::::::::
            ModalMySelectRoomCheckList
        :::::::::::::::::::::::::::::::::::::::::::::::::-->
        <div class="modal_container MySelectRoomCheckList">
            <div class="wrap">
                <!-- Title -->
                <div class="title">
                    <h3><span>ショップを選択してください</span></h3>
                </div><!-- /.Title -->
                <!-- Text -->
                <div class="text-wrap">
                    <div class="inner">

                        <p>選択したショップはブランドやショールームからのお知らせ、AUMAトークが可能になります。</p>

                        <ul class="list_common _full">

                            <li class="item form_checkbox _all">
                                <input type="checkbox" name="my-select-room-add" id="my-select-room-add0">
                                <label for="my-select-room-add0">
                                    <div class="check-mark"><span></span></div>
                                    <span>Name0</span>
                                </label>
                            </li>

                            <li class="item form_checkbox _all">
                                <input type="checkbox" name="my-select-room-add" id="my-select-room-add1">
                                <label for="my-select-room-add1">
                                    <div class="check-mark"><span></span></div>
                                    <span>Name1</span>
                                </label>
                            </li>

                            <li class="item form_checkbox _all">
                                <input type="checkbox" name="my-select-room-add" id="my-select-room-add2">
                                <label for="my-select-room-add2">
                                    <div class="check-mark"><span></span></div>
                                    <span>Name2</span>
                                </label>
                            </li>

                            <li class="item form_checkbox _all">
                                <input type="checkbox" name="my-select-room-add" id="my-select-room-add3">
                                <label for="my-select-room-add3">
                                    <div class="check-mark"><span></span></div>
                                    <span>Name3</span>
                                </label>
                            </li>

                        </ul>

                        <!-- Button -->
                        <div class="button-wrap">
                            <button type="button" class="cancel" v-on:click="modalCloseClick"><span>キャンセル</span></button>
                            <button type="button"><span>OK</span></button>
                        </div><!-- /.button-wrap -->

                    </div><!-- /.Inner -->
                </div><!-- /.Text -->
                <div class="close-icon"><span></span><span></span></div>
            </div><!-- /.Wrap -->
            <div class="modal_close-ovl" v-on:click="modalCloseClick"></div>
        </div><!-- /.ModalContainer -->

        <!-- モーダル要素 ここまで -->

    </section>

</template>

<script>
    import commonMixins from '@/common/utility.js'

    //Svg
    import SvgIconCancel from '@/components/EndUser/svg/SvgIconCancel'
    import SvgIconCheck from '@/components/EndUser/svg/SvgIconCheck'

    export default {
        mixins: [commonMixins],
        components: {
            //Svg
            SvgIconCancel,
            SvgIconCheck,
        },
    }
</script>
